/**
 * SignIn
 */

/**
 * TODO get rid of this container (move directly to routes perhaps)
 * routes call the authentication container directly when the user lands on "/account/signin
 */

import React from 'react';
import PropTypes from 'prop-types';
import autobind from 'class-autobind';
import { get } from 'lodash';

import { connect } from 'react-redux';

import Authentication from 'pages/Authentication';

export class SignIn extends React.Component {
	constructor(props) {
		super(props);
		autobind(this);
		const nextPath = get(this.props, 'location.state.next', '/');

		this.state = {
			forwardTo: nextPath
		};
	}

	// Note: I can't seem to locate a user flow where this is called anymore.
	// Perhaps this is a candidate for deletion, but will leave it for now,
	// just in case. I did modify the conditional to be more streamlined.
	UNSAFE_componentWillReceiveProps(nextProps) { // eslint-disable-line camelcase
		if (
			get(this.props, 'location.state.next', false) &&
			!get(nextProps, 'location.state.next', false)
		) {
			this.setState({ forwardTo: get(this.props, 'location.state.next', '/') });
		} else if (
			get(nextProps, 'location.state.next', false)
		) {
			this.setState({ forwardTo: get(nextProps, 'location.state.next', '/') });
		}
	}

	render() {
		const { location } = this.props;
		const { forwardTo } = this.state;

		return (
			<Authentication
				email={ get(location, 'state.email') }
				forceAuthentication={ get(location, 'state.forceAuthentication') }
				location={ location }
				nextLocation={ forwardTo }
				passthroughPassword={ get(location, 'state.password', '') }
				signInType="page"
				step={ get(location, 'query.step') }
			/>
		);
	}
}

SignIn.propTypes = {
	location: PropTypes.object
};

SignIn.defaultProps = {
	location: null
};

function mapDispatchToProps(dispatch) {
	return {
		dispatch
	};
}

export default connect(null, mapDispatchToProps)(SignIn);
